import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';

@Pipe({
  name: 'loadWorkflowDetailsPipe'
})
export class loadWorkflowDetailsPipe implements PipeTransform {

  transform(dataItem: any, workflowList: any[]): WorkflowTemplateModel[] {
    return workflowList.filter(g => g.scheduleType == dataItem.schedule_Type)
  }

}
